export default {
	tabs: ["Abheben", "Verlauf"],
	History: {
		tabs: ["In Prüfung", "Erfolgreich", "Abgelehnt"]
	},
	Withdraw: {
		label: ["Kontonummer", "Bestellnummer", "Adresse", "Betrag", "Gebühr", "Erstellt am", "Status", "Grund"]
	},
	AccountAmount: "Kontostand",
	tips: "Sie erhalten Ihre Auszahlung innerhalb einer Stunde",
	form: {
		label: ["Auszahlungsbetrag", "Transaktionspasswort"],
		ALL: "ALLES",
		Withdraw: "Absenden"
	},
	WithdrawAccount: "Auszahlungskonto",
	noAccountsTips: "Bitte Zahlungsmethoden hinzufügen",
	tradingKind: [
		"Rückerstattung",
		"Abzug",
		"Aufladung",
		"Auszahlung läuft",
		"Auszahlungsfreigabe",
		"Auszahlung",
		"Aufgabe",
		"Rückzahlung des Kapitals",
		"Rückzahlung der Provision",
		"Rückzahlung der Unterprovision",
		"Check-in",
		"Bearbeitungsgebühr",
		"Einzahlung",
		"Belohnung",
		"Grundgehalt",
		"Bargeldhilfe",
		"Registrierungsbonus",
		"Waren-Dividenden",
		"Aufgabenbonus",
		"Andere",
		"",
		"Arbeitsbonus",
		"Upgrade-Belohnungen",
		"Subvention",
		"Ausstehende Verifizierung",
		"Kampagne",
		"Punkteeinlösung",
		"Login-Belohnungen",
		"Arbeitsbelohnungen",
		"Kreditpunkte-Transaktion"
	]
};
